import {
  applyMiddleware, combineReducers, createStore, compose,
} from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import ReduxThunk from 'redux-thunk';
import authReducer from './reducer/auth.reducer';
import orderReducer from './orders/orders.reducer';
import userReducer from './reducer/user.reducer';
import productReducer from './reducer/products.reducer';
import logReducer from './reducer/logs.reducer';
import reportsReducer from './reports/reports.reducer';
import loansReducer from './loans/loans.reducer';

import appSlice from './slice/appSlice';
import userSlice from './slice/userSlice';
import reportSlice from './slice/reportSlice';
import loanSlice from './slice/loanSlice';
import authenticationSlice from './slice/authenticationSlice';

const reducer = combineReducers({
  authReducer,
  orderReducer,
  userReducer,
  productReducer,
  logReducer,
  reportsReducer,
  loansReducer,
  app: appSlice,
  users: userSlice,
  reports: reportSlice,
  loans: loanSlice,
  authentication: authenticationSlice,
});

const persistConfig = {
  key: 'rewot',
  storage,
  whitelist: ['authentication', 'app'],
};
const rootReducer = persistReducer(persistConfig, reducer);

const store = createStore(
  rootReducer,
  compose(applyMiddleware(ReduxThunk)),
);
const persistor = persistStore(store);

export {
  store,
  persistor,
};
